import { ActivityType, TierIiReportKind } from "generated-graphql/graphql";

import { isLepcPortalActivity } from "../useRelevantPortalCredential";

export const inferActionFromDescription = (description?: string | null): string => {
  if (isLepcPortalActivity(description)) {
    return "inputDataLepc";
  }

  const desc = description?.toLowerCase() ?? "";
  if (desc.includes("download receipt")) {
    return "finalizeSubmission";
  }
  if (desc.includes("downloadreport")) {
    return "downloadReport";
  }
  return "inputData";
};

export const getDefaultInputActionForReportKind = (
  reportKind?: TierIiReportKind | null
): string => {
  if (reportKind === TierIiReportKind.Revision) {
    return "inputDataRevision";
  }
  if (reportKind === TierIiReportKind.NewlyNotReporting) {
    return "inputDataNewlyNotReporting";
  }

  return "inputData";
};

export const getGeppettoAction = (
  activityType?: ActivityType,
  jobAction?: string | null,
  activityDescription?: string | null,
  reportKind?: TierIiReportKind | null
) => {
  if (jobAction) {
    return jobAction;
  }

  if (activityType === ActivityType.Geppetto) {
    const inferredAction = inferActionFromDescription(activityDescription);
    if (inferredAction === "inputData") {
      return getDefaultInputActionForReportKind(reportKind);
    }

    return inferredAction;
  }

  if (activityType === ActivityType.CollectEvidence) {
    return "collectEvidenceOfCompletion";
  }

  return "";
};

export const buildGeppettoCommand = ({
  action,
  reportingYear,
  reportKind,
  facilityId,
  jobId,
  credentialId,
}: {
  action: string;
  reportingYear?: number | null;
  reportKind?: string | null;
  facilityId?: string | null;
  jobId?: string | null;
  credentialId?: string | null;
}) => {
  const baseCmd = `yarn encamp geppetto --action ${action} --reporting-year ${reportingYear} --report-kind ${reportKind} --facility-id ${facilityId}`;
  const jobFlag = jobId ? `--job-id ${jobId}` : "--create-job";
  const credentialFlag = credentialId ? `--credential-id ${credentialId}` : "";

  return `${baseCmd} ${jobFlag} ${credentialFlag}`.trim();
};
